import { type AirActionTrackingLocation } from '@air/analytics';
import { type JustifiedBox } from '@air/component-gallery-view';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { type GetItemMenuOptions } from '~/constants/MenuOptions';

export type GetSelectionMenuOptionsType = (
  trackLocation: AirActionTrackingLocation,
  isDark?: boolean,
) => DropdownMenuOption[];

export type ItemProps = {
  /** Callback that is passed the item when clicked */
  onItemClick: (trackLocation: AirActionTrackingLocation) => void;
  onItemCmdClick?: (trackLocation: AirActionTrackingLocation) => void;

  /** Callback that is passed when custom fields are clicked */
  onCustomFieldsClick?: () => void;
  /** A boolean determining if the item is selectable */
  isSelectable: boolean;
  /** Callback that is passed the item to get back the submenu options that show in the ellipsis menu */
  getItemMenuOptions: GetItemMenuOptions;
  /** Callback that returns options to show when item is selected */
  getSelectionMenuOptions: GetSelectionMenuOptionsType;
};

export type AssetItemProps = {
  /** Callback that is passed when comments are clicked */
  onCommentsClick?: () => void;
  /** Callback that is passed when versions are clicked */
  onVersionsClick?: () => void;
} & ItemProps;
export enum GalleryItemType {
  board = 'board',
  topLevelBoard = 'topLevelBoard',
  asset = 'asset',
  file = 'file',
  rive = 'rive',
  loader = 'loader',
  upload = 'upload',
  header = 'header',
  person = 'person',
  canvas = 'canvas',
}

export type GalleryViewRender<T> = {
  index: number;
  box: JustifiedBox;
  data: T;
};
